// lazyload
import LazyLoad from "vanilla-lazyload";

import mainNav from "../modules/mainNav.js";

import accordionsContainer from "../modules/accordionsContainer";

import { wpcf7Validation } from "../modules/wpcf7Utilities.js";

import countUp from "../modules/countUp.js";

import interactiveMap from "../modules/interactiveMap.js";

import tabs from "../modules/tabs.js";

import modal from "../modules/modal.js";

// import gsapParallax from "../modules/gsapParallax";

// import { parallaxReveal } from "../modules/gsapReveals";

// woocommerce interactive notices
import wooNotices from "../modules/wooNotices";

import RentCalc from "../modules/rentCalc.js";

window.addEventListener('load', () => {
    const lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy"
    });

    new mainNav('.main-menu', '.main-nav', '.main-menu__toggle');

    // reveal init
    require('../modules/reveal');

    accordionsContainer('.js-acc-main', '.js-acc-item', '.js-acc-toggle', '.js-acc-body', true);

    // swipers init
    require('../modules/swipers');

    // fslightbox gallery
    require('fslightbox');

    require('../modules/lightboxWPGallery');

    wpcf7Validation();
    
    countUp(".js-countup-trigger", ".js-countup-target", 2, 0.5);

    wooNotices();

    // sec3Parallax('.gsap-parallax');
    // parallaxReveal('.js-gsap-parralax-reveal');

    interactiveMap();

    tabs();

    modal();

    new RentCalc();
});
